module.exports = __webpack_public_path__ + "3885c73cea0e1cc9e377966bbce1eb7b.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/sleeping-14.png
// module id = 2155
// module chunks = 0